angular.module('impactx.purchaseorder').directive('ixAdditionalOrderInfo', function () {
    return {
        scope: {
            readOnly: '=',
            cardTitle: '@',
            requestUser: '=',
            requestReason: '='
        },
        restrict: 'E',
        templateUrl: 'modules/purchaseorder/templates/additionalorderinfo.tmpl.html'
    };
});